import React from "react";

export default function PostSkeletonCard() {
    return (
        <>
            <style>{`
                @keyframes shimmer {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
            `}</style>

            <div className="bg-white dark:bg-boxdark rounded-xl shadow-md p-4 mb-5 mx-auto max-w-2xl min-h-[350px]">
                {/* Header */}
                <div className="flex justify-between items-start mb-4">
                    <div className="flex items-center space-x-3">
                        <ShimmerBox className="h-12 w-12 rounded-full" />
                        <div>
                            <ShimmerBox className="h-5 w-36 rounded mb-2" />
                            <ShimmerBox className="h-4 w-24 rounded" />
                        </div>
                    </div>
                    <ShimmerBox className="h-5 w-8 rounded" />
                </div>

                {/* Title */}
                <ShimmerBox className="h-6 w-4/5 rounded mb-3" />

                {/* Content lines */}
                <div className="space-y-2 mb-4">
                    <ShimmerBox className="h-4 w-full rounded" />
                    <ShimmerBox className="h-4 w-5/6 rounded" />
                    <ShimmerBox className="h-4 w-2/3 rounded" />
                </div>

                {/* Image */}
                <ShimmerBox className="h-56 w-full rounded-lg mb-4" />

                {/* Footer */}
                <div className="flex space-x-4 mt-2">
                    <ShimmerBox className="h-9 w-9 rounded-full" />
                    <ShimmerBox className="h-9 w-9 rounded-full" />
                    <ShimmerBox className="h-9 w-9 rounded-full" />
                </div>
            </div>
        </>
    );
}

function ShimmerBox({ className }) {
    return (
        <div className={`relative overflow-hidden ${className}`}>
            {/* Light mode background and shimmer */}
            <div className="block dark:hidden absolute inset-0">
                <div
                    className="absolute inset-0"
                    style={{ background: "#dcdce65e" }} // custom light mode base background
                />
                <div
                    className="absolute inset-0 animate-[shimmer_1.5s_infinite]"
                    style={{
                        background:
                            "linear-gradient(90deg, transparent, rgba(179,181,185,0.15), transparent)",
                    }}
                />
            </div>

            {/* Dark mode background and shimmer */}
            <div className="hidden dark:block absolute inset-0">
                <div
                    className="absolute inset-0"
                    style={{ background: "#1f2937" }} // Tailwind gray-800 or custom dark base
                />
                <div
                    className="absolute inset-0 animate-[shimmer_1.5s_infinite]"
                    style={{
                        background:
                            "linear-gradient(90deg, transparent, rgba(209,213,219,0.15), transparent)",
                    }}
                />
            </div>
        </div>
    );
}